<template>
  <v-flex class="card-sop">
    <v-flex pa-3>
      <v-layout justify-between align-center wrap direction="row">
        <v-flex xs9>
          <h6 class="mb-1 font-weight-bold mt-0" style="word-break: break-all">
            {{ item.name }}
          </h6>
        </v-flex>
        <v-flex xs3 text-xs-right>
          <ToggleButton
            :value="item.active"
            @change="$emit('changeActive', item)"
            :color="$vuetify.theme.success"
            :labels="{ checked: 'ON', unchecked: 'OFF' }"
            style="display: inline-block"
          />

          <v-btn
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="$emit('editSop', item)"
          >
            <em class="fas fa-pencil-alt" />
          </v-btn>
          <v-btn
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="$emit('duplicateSop', item)"
          >
            <em class="fa fa-copy middle" />
          </v-btn>
          <v-btn
            fab
            outline
            color="primary"
            class="extra-small ma-1"
            @click="$emit('deleteSop', item.id)"
          >
            <em class="fa fa-trash middle" />
          </v-btn>
        </v-flex>
      </v-layout>
      <p class="mb-0">ระยะเวลา: {{ item.day_length }} วัน</p>
      <p class="mb-0">สังกัด: {{ item.affiliation }}</p>
      <p class="mb-0">แผนก: {{ item.department }}</p>
    </v-flex>

    <v-flex class="notification-message" pa-3>
      <p class="message mb-0 pa-2 d-inline-block">
        {{ notificationMessage }}
      </p>
    </v-flex>
  </v-flex>
</template>

<script>
import hopinnHrApi from '@/api/hopinn-hr'
import { ToggleButton } from 'vue-js-toggle-button'
export default {
  props: ['item'],
  components: {
    ToggleButton
  },
  data() {
    return {}
  },
  computed: {
    notificationMessage() {
      try {
        const intents = JSON.parse(this.item.a_val)

        return intents[0][0].text
      } catch (error) {
        return '-'
      }
    }
  },
  async mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.card-sop {
  border: 1px solid #ff706b;
  margin: 15px auto 0;
  border-radius: 10px 10px;
  overflow: hidden;
  p {
    color: #333;
  }
}

.notification-message {
  border-top: 1px solid #ddd;
  background-color: #f5f5f5;
  .message {
    border-radius: 6px;
    border: 1px solid #ddd;
    background-color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/HopinnHr/CardSop.vue